import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { sanitizeHtml } from "@/lib/richText";

export default function StaticPage({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPage(null); setError(false);
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="mx-auto max-w-2xl px-4 py-24 text-center text-slate-500">Page not found.</div>;

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">{page?.title || "..."}</h1>
      <div className="rich-content mt-6" data-testid="static-page-content"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(page?.content || "") }} />
    </div>
  );
}
